module.exports = __webpack_public_path__ + "static/assets/27c1f5df71132af31c37d858f7817f08.svg";